export const suppliersContants = {
  GET_ALL_SUPPLIERS: "GET_ALL_SUPPLIERS",
};
